import styled from 'styled-components';

export const StyledCheckboxList = styled.ul`
  width: 100%;
`;

export const StyledCheckboxListItem = styled.li`
  display: flex;
  align-items: center;
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

export const StyledCheckboxWrapper = styled.div`
  min-width: 9rem;
  flex-shrink: 0;
`;

export const StyledSelectWrapper = styled.div`
  flex-grow: 1;
`;
